import apiClient from './api';

const onError = (error) => { console.error(error); };

export const getFloorPlanZones = (id) => {
    return apiClient.post("api/floor-plan-area/get-areas", { floor_plan_id: id }).catch(onError);
};

export const createFloorPlanZone = (zone) => {
    return apiClient.post("api/floor-plan-area/create", zone).catch(onError);
};

export const updateFloorPlanZone = (zone) => {
    return apiClient.post("api/floor-plan-area/update", zone).catch(onError);
};

export const deleteFloorPlanZone = (zone) => {
    return apiClient.post("api/floor-plan-area/delete", zone).catch(onError);
};
